import React from "react";
import Link from "next/link";
import LocationSvg from "/public/images/icons/location.svg";
import EnvelopeSvg from "/public/images/icons/envelope.svg";
import PhoneSvg from "/public/images/icons/phone.svg";
import LogoSvg from "/public/images/logos/deviatelabs/sealText.svg";

import css from "./index.module.scss";
import RevealedText from "@/components/revealedText";
import Button from "@/components/button";
import FloatingImage from "@/components/floatingImage";

export default function FloatingImageSection({
  headlines = [],
  subheadlines = null,
  ctaLabel = null,
  ctaUrl = null,
  floatingImageBase = "/images/floatingImages/rubicksCube/rubicksCube",
  floatingImageLoading = "lazy",
  floatingImageSizes = ["180", "384", "640"],
  reversed = false,
  className = "",
  children = null,
  component = null,
}) {
  let finalClassName = `section ${className} ${css.floatingImageSection}`;
  if (reversed){
    finalClassName += ` ${css.reversed}`;
  }

  return <section className={finalClassName}>
    <div className="sectionInner">
      <h2>
        <RevealedText
          texts={headlines}
          color="#ffffff"
        />
      </h2>
      <div className={`slideIn ${css.body}`}>
        {subheadlines && <h3>
          {subheadlines.map((subheadline) => <span key={subheadline}>{subheadline}</span>)}
        </h3>}

        {children}

        {ctaLabel && ctaUrl && <div className={css.cta}>
          <Button label={ctaLabel} href={ctaUrl} light ghost/>
        </div>}
      </div>
      {!component && <div className={css.floatingImageWrapper}>
        <FloatingImage
          file={floatingImageBase}
          sizes={floatingImageSizes}
          loading={floatingImageLoading}
        />
      </div>}
      {component && <div className={css.floatingImageWrapper}>
        {component}
      </div>}
    </div>
  </section>;
}

